import { Box, Chip, Tooltip } from '@mui/material';
import type { ExceptionsSummary } from './publicationExceptionsApi';

/**
 * Pozycja „Wnioski o wyjątek” w menu z licznikiem wniosków czekających na
 * decyzję pytającego (makieta back office v2, fala B, 21.10.2026 — widok
 * Sales „Akceptacje” z liczbą). Licznik tylko dla rozstrzygających; zero
 * i brak odpowiedzi — sama etykieta. Odczyt robi menu
 * (`useExceptionsSummary`), etykieta tylko rysuje.
 */
export const PublicationExceptionsMenuLabel = ({
  label,
  summary,
}: {
  label: string;
  summary: ExceptionsSummary | null;
}) => {
  const waiting = summary?.canDecide ? summary.pendingToDecide : 0;
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
      <span>{label}</span>
      {waiting > 0 ? (
        <Tooltip title={`Wnioski czekające na Twoją decyzję: ${waiting}`}>
          <Chip
            size="small"
            color="warning"
            label={waiting}
            data-testid="publication-exceptions-count"
            sx={{ height: 18, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
          />
        </Tooltip>
      ) : null}
    </Box>
  );
};
